/**
 * Homepage — UGC carousel ("Najszczęśliwsze miski w Polsce").
 *
 * Strip jest natywnie scrollable (overflow-x:auto + scroll-snap-type:x mandatory)
 * — strzałki tylko triggerują `scrollBy` o szerokość jednego kafelka + gap.
 *
 * Markup (z partials/homepage/ugc.php):
 *   <div data-hn-ugc-carousel>
 *     <button data-hn-ugc-prev>...</button>
 *     <div data-hn-ugc-track>
 *       <figure class="hn-ugc__tile">...</figure>
 *       ...
 *     </div>
 *     <button data-hn-ugc-next>...</button>
 *   </div>
 *
 * Plus: disabled state + opacity gdy klient na początku/końcu listy.
 * Touch / drag-to-scroll działa natywnie (overflow-x:auto), nie wymaga JS.
 */
export function initUgcCarousel() {
    const carousels = document.querySelectorAll('[data-hn-ugc-carousel]');
    if (!carousels.length) return;

    carousels.forEach((carousel) => {
        const track = carousel.querySelector('[data-hn-ugc-track]');
        const prevBtn = carousel.querySelector('[data-hn-ugc-prev]');
        const nextBtn = carousel.querySelector('[data-hn-ugc-next]');
        if (!track || !prevBtn || !nextBtn) return;

        /* Scroll delta = pierwszy kafelek + gap (z computed style track'a). */
        const getScrollDelta = () => {
            const tile = track.querySelector('.hn-ugc__tile');
            if (!tile) return 240;
            const style = window.getComputedStyle(track);
            const gap = parseFloat(style.gap || style.columnGap) || 0;
            return tile.offsetWidth + gap;
        };

        const scrollBy = (direction) => {
            track.scrollBy({
                left: direction * getScrollDelta(),
                behavior: 'smooth',
            });
        };

        prevBtn.addEventListener('click', () => scrollBy(-1));
        nextBtn.addEventListener('click', () => scrollBy(1));

        /* Klawiatura — Left/Right gdy któryś z buttonów ma focus.
         * Default browser ignoruje arrows na <button>, dlatego key handler. */
        const onKey = (e) => {
            if (e.key === 'ArrowLeft')  { e.preventDefault(); scrollBy(-1); }
            if (e.key === 'ArrowRight') { e.preventDefault(); scrollBy(1); }
        };
        prevBtn.addEventListener('keydown', onKey);
        nextBtn.addEventListener('keydown', onKey);

        /* Update disabled / opacity gdy strip jest na początku/końcu.
         * Throttle przez rAF żeby `scroll` event nie spamował. */
        const updateButtons = () => {
            const atStart = track.scrollLeft <= 1;
            const atEnd   = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
            prevBtn.disabled = atStart;
            nextBtn.disabled = atEnd;
            prevBtn.classList.toggle('is-disabled', atStart);
            nextBtn.classList.toggle('is-disabled', atEnd);
        };

        let ticking = false;
        track.addEventListener('scroll', () => {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(() => {
                updateButtons();
                ticking = false;
            });
        });

        /* Initial state + on resize (np. mobile rotate, viewport zmienia tile width). */
        updateButtons();
        let resizeTimer = null;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(updateButtons, 100);
        });
    });
}
